/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { FilterDocumentDto } from '../../models/filter-document-dto';
import { ResponseDocumentDto } from '../../models/response-document-dto';

export interface DocumentsControllerFilterDocuments$Params {
      body: FilterDocumentDto
}

export function documentsControllerFilterDocuments(http: HttpClient, rootUrl: string, params: DocumentsControllerFilterDocuments$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResponseDocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerFilterDocuments.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ResponseDocumentDto>>;
    })
  );
}

documentsControllerFilterDocuments.PATH = '/thalea-documents/documents/filter';
